module.exports = __webpack_public_path__ + "static/KIN2-a38de1181f64bb3a90e34f66f5a751ed.png";